import { getGetCapitalActivitiesDataGatewayViewMockHandler } from "@vega-api/generated/capital-activity-data-gateway-v1/capital-activity-data-gateway-v1.msw";
import { getGetFundsDataGatewayViewMockHandler } from "@vega-api/generated/fund-ingestion-v1/fund-ingestion-v1.msw";
import { getGetInvestmentsDataGatewayViewMockHandler } from "@vega-api/generated/investment-data-gateway-v1/investment-data-gateway-v1.msw";
import { getGetInvestorDocumentsDataGatewayViewMockHandler } from "@vega-api/generated/investor-document-data-gateway-v1/investor-document-data-gateway-v1.msw";
import { getGetLegalEntitiesDataGatewayViewMockHandler } from "@vega-api/generated/legal-entity-data-gateway-v1/legal-entity-data-gateway-v1.msw";
import { getGetLimitedPartnersDataGatewayViewMockHandler } from "@vega-api/generated/limited-partner-ingestion-v1/limited-partner-ingestion-v1.msw";
import { getGetInvestmentMetricsDataGatewayViewMockHandler } from "@vega-api/generated/metric-data-gateway-v1/metric-data-gateway-v1.msw";
import { getGetFundOpportunitiesDataGatewayViewMockHandler } from "@vega-api/generated/opportunity-ingestion-v1/opportunity-ingestion-v1.msw";
import { getGetUsersDataGatewayViewMockHandler } from "@vega-api/generated/user-ingestion-v1/user-ingestion-v1.msw";
import { getGetUserRolesDataGatewayViewMockHandler } from "@vega-api/generated/user-role-ingestion-v1/user-role-ingestion-v1.msw";
import { getGetWireInstructionsDataGatewayViewMockHandler } from "@vega-api/generated/wire-instruction-ingestion-v1/wire-instruction-ingestion-v1.msw";

import {
  capitalActivitiesMockData,
  fundsMockData,
  investmentMetricsMockData,
  investmentsMockData,
  investorDocumentsMockData,
  limitedPartnersMockData,
  opportunitiesMockData,
  organizationsMockData,
  userRolesMockData,
  usersMockData,
  wireInstructionsMockData,
} from "./idManagerMockData";

export const idManagerHandlers = [
  getGetLegalEntitiesDataGatewayViewMockHandler(organizationsMockData),
  getGetUsersDataGatewayViewMockHandler(usersMockData),
  getGetUserRolesDataGatewayViewMockHandler(userRolesMockData),
  getGetInvestmentsDataGatewayViewMockHandler(investmentsMockData),
  getGetFundOpportunitiesDataGatewayViewMockHandler(opportunitiesMockData),
  getGetWireInstructionsDataGatewayViewMockHandler(wireInstructionsMockData),
  getGetLimitedPartnersDataGatewayViewMockHandler(limitedPartnersMockData),
  getGetInvestmentMetricsDataGatewayViewMockHandler(investmentMetricsMockData),
  getGetInvestorDocumentsDataGatewayViewMockHandler(investorDocumentsMockData),
  getGetCapitalActivitiesDataGatewayViewMockHandler(capitalActivitiesMockData),
  getGetFundsDataGatewayViewMockHandler(fundsMockData),
];
